const translations = {
  "en": {
    "Continue with email": "Continue with email",
    "Sign in / Sign up": "Sign in / Sign up"
  },
  "zh-tw": {
    "Continue with email": "以電子郵件繼續",
    "Sign in / Sign up": "登入 / 註冊"
  }
};

export default translations;
